import { isSkipLotResyncAfterBootEnabled } from './bootFeatureFlags';

const SKIP_WINDOW_MS = 500;
let lastBootLotsApplyAt = 0;

export function markBootLotsApplied() {
  lastBootLotsApplyAt = Date.now();
}

export function shouldSkipLotResyncAfterBoot() {
  if (!isSkipLotResyncAfterBootEnabled()) return false;
  if (!lastBootLotsApplyAt) return false;
  return Date.now() - lastBootLotsApplyAt < SKIP_WINDOW_MS;
}
